@if (company_product) {
  <ng-container [formGroup]="filterForm">
    <div class="lateral-sidebar-structure" [style.grid-template-columns]="showColumn ? '250px 1fr' : '1fr'">
      @if (showColumn) {
        <nav>
          <div [formGroup]="filterForm">
            <mat-button-toggle-group formControlName="mode" style="width: 100%; display: flex; margin-bottom: 10px">
              <mat-button-toggle value="all" style="flex: 1">Todas</mat-button-toggle>
              <mat-button-toggle value="assigned" style="flex: 1">Mías</mat-button-toggle>
              <mat-button-toggle value="listening" style="flex: 1">Sigo</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <ul>
            @for (board of boards; track board) {
              <li routerLinkActive="active" [matTooltip]="board.title">
                <a
                  class="board-title d-flex align-items-center justify-content-between gap-2"
                  [class.nonactive]="board.status === 'finished'"
                  [class.active]="board.status === 'active'"
                  [routerLink]="[board.id]"
                  [queryParams]="filterForm.value"
                >
                  <div class="d-flex flex-column grow min-w-0" style="min-width: 0">
                    @if (board.is_archived) {
                      <mat-icon>archive</mat-icon>
                    }
                    <span class="text-truncate">
                      {{ board.title ?? 'Sprint ' + (boards.indexOf(board) + 1) }}
                    </span>
                    @if (board.status === 'active') {
                      <div style="font-size: 10px">{{ getDiferenceInDays(board.end_date!) }} días restantes</div>
                    }
                  </div>
                  @if (can_act_as_product_manager()) {
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="boardMenu"
                      class="small-icon-button"
                      (click)="$event.stopPropagation()"
                      (click)="$event.preventDefault()"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #boardMenu="matMenu">
                      <button mat-menu-item (click)="openBoardSettings(board)">
                        <mat-icon>settings</mat-icon>
                        Configuración de tablero
                      </button>
                      @if (board.status === 'not_started') {
                        <button mat-menu-item (click)="deleteBoard(board)">
                          <mat-icon>delete</mat-icon>
                          Eliminar tablero
                        </button>
                      }
                    </mat-menu>
                  }
                </a>
              </li>
            }
          </ul>

          <div class="d-flex gap-2">
            <button mat-stroked-button [matMenuTriggerFor]="listMenu" style="margin-top: 5px; width: 100%">
              <mat-icon>more_horiz</mat-icon>
              Otras acciones
            </button>
            <mat-menu #listMenu="matMenu">
              @if (can_act_as_product_manager()) {
                <button mat-menu-item (click)="openCreateBoard()">
                  <mat-icon>add</mat-icon>
                  Crear tablero
                </button>
              }
              <button mat-menu-item (click)="showColumn = !showColumn">
                <mat-icon>{{ showColumn ? 'visibility_off' : 'visibility' }}</mat-icon>
                {{ showColumn ? 'Esconder' : 'Mostrar' }} columna lateral
              </button>
              <div class="field" mat-menu-item (click)="$event.stopPropagation()">
                <mat-checkbox formControlName="show_archived_boards">Ver tableros archivados</mat-checkbox>
              </div>
            </mat-menu>
            <button mat-icon-button (click)="refetchBoard()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </nav>
      }
      <div class="lateral-sidebar-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-container>
}
